/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_ItalicInputs */



/**
* | output |
* | --- |
* | "Italic" |
*
* @param {Rte_ItalicInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_italic = /** @type {((inputs?: Rte_ItalicInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_ItalicInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Cursief")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Italique")
	return /** @type {LocalizedString} */ ("Italic")
});